import React, { FunctionComponent } from 'react';

import { getApiData } from 'scenes/common/helpers/apiData';
import SingleSelectStep from 'scenes/common/components/Steps/SingleSelectStep';
import { InsuredItem } from 'scenes/common/types';
import { HomeFullPageProps } from 'scenes/home/types';
import { getPropertyBusinessType } from 'scenes/home/selectors';

const PROPERTY_BUSINESS_TYPE = 'propertyBusinessType';
export const QUESTION = `What is the main type of business the ${InsuredItem.Home} is used for?`;

const PropertyBusinessTypeStep: FunctionComponent<HomeFullPageProps> = ({
  funnelState,
  onNext,
  referenceData,
}) => {
  const { businessTypes } = getApiData(referenceData);

  return (
    <SingleSelectStep
      options={businessTypes}
      stateKey={PROPERTY_BUSINESS_TYPE}
      question={QUESTION}
      defaultStateValue={getPropertyBusinessType(funnelState)}
      onNext={onNext}
    />
  );
};

export default PropertyBusinessTypeStep;
